var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-input',{attrs:{"placeholder":"请输入商品标签"},on:{"input":_vm.sendName},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }